var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrap"},[_c('van-image',{attrs:{"width":"64","height":"64","src":"./imgs/loading.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }